import React from 'react'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { IoIosArrowDown } from "react-icons/io";
import { useTranslation } from 'react-i18next';

const LanguagesDrop = (props) => {
  const { t , i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <Menu as="div" className={`relative inline-block text-left ${isRTL ? '!font-cairo' : 'font-manrope'}`}>
      <div>
        <MenuButton className={`flex justify-center items-center p-1 xxxxl:p-2 rounded-full ${props.className} shadow-sm`}>
          <IoIosArrowDown size={props.w}  aria-hidden="true" />
        </MenuButton>
      </div>

      <MenuItems
        transition
        className={`absolute ${isRTL ? 'left-2' : 'right-2'} z-[100000] mt-2 w-auto rounded-md ${props.classN1} shadow-lg transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in`}
      >
        <div className="py-1 flex flex-col">
          <MenuItem>
            <button onClick={() => changeLanguage('fr')} className={`px-4 py-2 text-sm ${props.classN} data-[focus]:outline-none`}>
              Français
            </button>
          </MenuItem>
          <MenuItem>
            <button onClick={() => changeLanguage('en')} className={`px-4 py-2 text-sm ${props.classN} data-[focus]:outline-none`}>
              English
            </button>
          </MenuItem>
          <MenuItem>
            <button onClick={() => changeLanguage('ar')} className={`px-4 py-2 text-sm ${props.classN} data-[focus]:outline-none`}>
              العربية
            </button>
          </MenuItem>
        </div>
      </MenuItems>
    </Menu>
  )
}

export default LanguagesDrop
